import { render, staticRenderFns } from "./deleteBlockTrigger.vue?vue&type=template&id=322cbcfe&scoped=true&"
import script from "./deleteBlockTrigger.vue?vue&type=script&lang=js&"
export * from "./deleteBlockTrigger.vue?vue&type=script&lang=js&"
import style0 from "./deleteBlockTrigger.vue?vue&type=style&index=0&id=322cbcfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cbcfe",
  null
  
)

export default component.exports